import { MIN_DURATION } from '../../../../../components/internal/DurationPicker/components/Inputs/constants.js';
export function isDurationInvalid(duration, maxDuration, minDuration = MIN_DURATION) {
  return duration.min < minDuration || duration.max < minDuration || duration.max >= maxDuration || duration.min >= maxDuration || duration.min > duration.max;
}